import { type FeatureConfigurationType } from '@repo/utils';

export const getFeatureConfiguration = `
query ($featureName: [String!]){
  featureConfiguration(featureName: $featureName){
    id
    featureName
    configKey
    configValue
    dataType
    createdAt
    updatedAt
  }
}
`;

export interface GetFeatureConfigurationType {
  featureConfiguration: FeatureConfigurationType[];
}
